import { render, staticRenderFns } from "./relatedLinkList.vue?vue&type=template&id=6d0fd614&scoped=true&"
import script from "./relatedLinkList.vue?vue&type=script&lang=js&"
export * from "./relatedLinkList.vue?vue&type=script&lang=js&"
import style0 from "./relatedLinkList.vue?vue&type=style&index=0&id=6d0fd614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0fd614",
  null
  
)

export default component.exports